var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInteractive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.137,
    height: 17.541,
    viewBox: "0 0 17.137 17.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.637 -2.502) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.234,6.878V9.223c.018,0,.018,0,.037-.018a2.318,2.318,0,0,1,.7-.111,2.008,2.008,0,0,1,.738.129V6.878A1.77,1.77,0,1,0,5.2,5.272,1.821,1.821,0,0,0,6.234,6.878Z",
    transform: "translate(-2.2 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.692,63.178H5.529V60.594L4.052,59.8v3.36H2.889a.384.384,0,0,0-.314.609l1.9,2.622a.381.381,0,0,0,.609,0l1.9-2.622A.372.372,0,0,0,6.692,63.178Z",
    transform: "translate(0 -45.906)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.328,27.294A4.173,4.173,0,0,0,22.3,24.82l-3.508-1.883a1.269,1.269,0,0,0-1.7,1.754l-.018-.018a1.269,1.269,0,0,0-1.7,1.754l-.018-.018a1.269,1.269,0,0,0-1.7,1.754L9.872,26.149a1.206,1.206,0,0,0-.978-.092,1.249,1.249,0,0,0-.757.609h0a1.276,1.276,0,0,0,.517,1.717L16,32.315a.161.161,0,0,1,.092.166.157.157,0,0,1-.129.148l-1.735.535a1.29,1.29,0,0,0-.388,2.271,1.255,1.255,0,0,0,1.015.222l4.948-.978a4.763,4.763,0,0,0,3.268-2.418l.942-1.772A4.1,4.1,0,0,0,24.328,27.294Z",
    transform: "translate(-4.473 -15.726)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractive);
export default __webpack_public_path__ + "static/media/interactive.d058ca1f8a954b5c5db8803a1ceb0a72.svg";
export { ForwardRef as ReactComponent };